import { Component, computed, inject, input, Input, signal } from '@angular/core';

import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, map, shareReplay } from 'rxjs';
import { environment } from 'src/index';
import { AuthenticationService, ChatService, isMobile } from 'src/index/services.index';
import { HasDashboardSidebar } from '../../shared/mixins/has-dashboard-sidebar.mixin';

@Component({
    selector: 'meta-code-of-conduct',
    templateUrl: './code-of-conduct.component.html',
    styleUrls: ['./code-of-conduct.component.css']
})
export class CodeOfConductComponent extends HasDashboardSidebar {
    $showOnlyContent = input(false, { alias: 'onlyContent' });
    authenticationService = inject(AuthenticationService);
    chatService = inject(ChatService);

    config = { ...environment.publicModule, hideSidebar: environment.dashboardModule?.hideSidebar, hideSidebarOnMobile: environment.dashboardModule?.hideSidebarOnMobile, hideUserMenu: environment.dashboardModule?.hideUserMenu };
    $hideFooter = computed(() => this.$showOnlyContent() || environment.hideFooter);
    $loggedIn = toSignal(this.authenticationService.checklogin().pipe(
        map(user => !!user),
        shareReplay(1),
    ))
    $hasSidebar = computed(() => !this.$showOnlyContent() && this.$loggedIn() && !this.config.hideSidebar && !(isMobile() && this.config.hideSidebarOnMobile));
    $sideBarShown = signal(!this.config.hideSidebar && !isMobile());
    override activeItem$ = new BehaviorSubject<string>('code-of-conduct');

    mainLogo = environment.logo;
    name = environment.name;

    codeOfConductTitle = this.chatService.getTitle();
    $codeOfConductSections = computed(() => this.chatService.getCodeOfConductText())
}
